import { defineComponent as _defineComponent } from 'vue'
import { Wallet } from 'ah-api-gateways';
import { FundsInTransitIcon } from 'ah-common-lib/src/icons/components';
import WalletsFormattedCurrency from '../currency/WalletsFormattedCurrency.vue';
import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'WalletInfoTitle',
  props: {
  wallet: {
    type: Object as PropType<Wallet>,
    required: true,
  },
  titleTag: {
    type: String,
    default: 'h2',
  },
  titleClass: {
    type: String,
    default: '',
  },
  subTitleTag: {
    type: String,
    default: 'p',
  },
  subTitleClass: {
    type: String,
    default: 'text-secondary mt-n3',
  },
},
  setup(__props) {



return { __sfc: true,FundsInTransitIcon, WalletsFormattedCurrency }
}

})